import React from "react";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {getGroups} from "../../../Services/campaignFunctions";
import {useGroupManager} from "../../Providers/groupManager";
import GroupListItem from "../GroupListItem";
import {Container, Header, List, State} from "./styles";

/**
 * Menu lateral "Editing Group": lista os grupos reais da campanha (nome + membros),
 * sem busca/filtros — usado pelas abas Group settings e Members.
 * A seleção é local (esqueleto); a área de conteúdo real é peça futura.
 * (O fetch é inline por ora, reusando getGroups; ao construir as telas dá pra
 * centralizar num hook/provider e evitar a duplicação com o GroupList do Inbox.)
 */
const GroupSidebar = () => {
    const {id} = useParams();
    const {t} = useTranslation();
    const {selectedGroup, setSelectedGroup} = useGroupManager();
    const [groups, setGroups] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        let alive = true;
        (async () => {
            setLoading(true);
            setError(false);
            const res = await getGroups(id);
            if (!alive) return;
            if (res?.isAxiosError || res instanceof Error) {
                setError(true);
                setGroups([]);
            } else {
                const list = Array.isArray(res) ? res : [];
                setGroups(list);
                // Pré-seleciona o 1º grupo SÓ quando o contexto ainda está vazio
                // (evita zerar a seleção do usuário quando a sidebar remonta ao trocar de aba).
                if (list.length && !selectedGroup) setSelectedGroup(list[0]);
            }
            setLoading(false);
        })();
        return () => {
            alive = false;
        };
    }, [id]);

    return (
        <Container>
            <Header>{t("words.editing_group")}</Header>
            <List>
                {loading && <State>{t("words.loading")}</State>}
                {!loading && error && <State>{t("words.something_wrong")}</State>}
                {!loading && !error && groups.length === 0 && (
                    <State>{t("words.no_groups")}</State>
                )}
                {!loading && !error && groups.map((group) => (
                    <GroupListItem
                        key={group.id}
                        group={group}
                        active={group.id === selectedGroup?.id}
                        onClick={() => setSelectedGroup(group)}
                    />
                ))}
            </List>
        </Container>
    );
};

export default GroupSidebar;
